import { useAuth } from "../../context/auth-context";
import type {
  AdminSpreadSummariesData,
  AdminSpreadSummariesEnvelope,
} from "./adminSpreadSummaries";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export type UseAdminSpreadSummariesParams = {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
};

/**
 * GET api/admin/transactions/summaries?type=spread[&startDate][&endDate]
 */
export function useAdminSpreadSummariesQuery(
  params: UseAdminSpreadSummariesParams = {}
) {
  const { isAuthenticated } = useAuth();
  const { startDate, endDate, enabled: enabledParam = true } = params;

  return useApiQuery<AdminSpreadSummariesEnvelope, AdminSpreadSummariesData>({
    queryKey: apiQueryKey("admin-transactions-summaries", {
      type: "spread",
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/summaries",
    params: {
      type: "spread",
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
